import { render } from "./LocationLabel.vue?vue&type=template&id=0830adf3"
import script from "./LocationLabel.vue?vue&type=script&lang=js"
export * from "./LocationLabel.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__